import type {
  ConditionDescriptor,
  ConditionFilterDescriptor,
} from "../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField } from "../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../api/types/svTypes.ts";

export const createLeafConditionDescriptor = (filter: ConditionFilterDescriptor): ConditionDescriptor => ({
  filter,
  conditions: [],
});

export const createNarrowingConditionDescriptor = (field: ConditionField): ConditionDescriptor | undefined => {
  const filter = field.config.filter;
  if (field.validation?.invalid || field.hasLinks || field.meta.type !== ItemDataType.General || filter === undefined) {
    return undefined;
  }

  const values = filter.values.filter((value) => value !== undefined);
  return values.length > 0 ? createLeafConditionDescriptor({ ...filter, values }) : undefined;
};

const getConditionFilter = (condition: ConditionDescriptor): ConditionFilterDescriptor | undefined => condition.filter;
const getConditionLeaves = (condition: ConditionDescriptor): ConditionDescriptor[] => {
  const leaves = condition.filter ? [condition] : [];
  return leaves.concat(condition.conditions.flatMap(getConditionLeaves));
};
const getConditionLeafDescriptors = (conditions: ConditionDescriptor[]): ConditionDescriptor[] => {
  return conditions.flatMap(getConditionLeaves);
};
export const getConditionLeafFilters = (conditions: ConditionDescriptor[]): ConditionFilterDescriptor[] => {
  return getConditionLeafDescriptors(conditions)
    .map(getConditionFilter)
    .filter((filter): filter is ConditionFilterDescriptor => filter !== undefined);
};
